import React from 'react';
import WeekMeetingForm from '../../../../components/forms/WeekMeetingForm';

export default function WeeksMeetingsCreatePage() {
  return <WeekMeetingForm />;
}
